import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthorityConnectionService } from '../services/authority-connection.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-authority-connection-banner',
  template: `
    <div *ngIf="visible" class="authority-banner-minimal">
      <span class="banner-message-minimal">{{ bannerMessage }}</span>
      <button
        type="button"
        class="connect-btn-minimal"
        (click)="connect($event)"
        [disabled]="isLoading"
      >
        {{ isLoading ? '...' : (service.status === 406 ? reconnectLabel : connectLabel) }}
      </button>
      <button type="button" class="close-btn-minimal" (click)="close($event)" title="إغلاق" aria-label="Close">&times;</button>
    </div>
  `,
  styles: [`
    .authority-banner-minimal {
      position: fixed;
      top: 0; left: 0; right: 0;
      background: #ffe0e0;
      color: #a00;
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: inherit;
      font-size: 1rem;
      box-shadow: 0 2px 8px rgba(211,47,47,0.08);
      border-bottom: 1px solid #d32f2f22;
      border-radius: 0 0 8px 8px;
      padding: 8px 12px;
      gap: 10px;
      min-width: 0;
      max-width: 480px;
      margin: 0 auto;
      animation: fadeInDown 0.3s;
    }
    @keyframes fadeInDown {
      from { opacity: 0; transform: translateY(-12px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .banner-message-minimal {
      flex: 1;
      text-align: right;
      font-weight: 500;
      font-size: 1em;
    }
    .connect-btn-minimal {
      background: #d32f2f;
      color: #fff;
      border: none;
      border-radius: 5px;
      padding: 4px 12px;
      font-size: 0.9em;
      cursor: pointer;
      white-space: nowrap;
      transition: background 0.2s;
    }
    .connect-btn-minimal:hover:not(:disabled) {
      background: #b71c1c;
    }
    .connect-btn-minimal:disabled {
      opacity: 0.6;
      cursor: default;
    }
    .close-btn-minimal {
      background: transparent;
      border: none;
      color: #d32f2f;
      font-size: 1.1em;
      cursor: pointer;
      padding: 2px 6px;
      border-radius: 50%;
      transition: background 0.2s;
      margin: 0;
    }
    .close-btn-minimal:hover {
      background: #ffdada;
    }
  `]
})
export class AuthorityConnectionBannerComponent implements OnInit, OnDestroy {
  visible = false;
  isLoading = false;
  private autoHideTimeout: ReturnType<typeof setTimeout> | null = null;
  private bannerSub?: Subscription;
  private readonly AUTO_HIDE_MS = 12000;

  readonly connectLabel = 'ربط الآن';
  readonly reconnectLabel = 'تجديد الربط';

  constructor(public service: AuthorityConnectionService) {}

  ngOnInit(): void {
    this.bannerSub = this.service.showBanner$.subscribe((show) => {
      this.visible = show;
      if (show) {
        if (this.autoHideTimeout != null) {
          clearTimeout(this.autoHideTimeout);
        }
        this.autoHideTimeout = setTimeout(() => {
          this.service.hideBanner();
        }, this.AUTO_HIDE_MS);
      } else {
        if (this.autoHideTimeout != null) {
          clearTimeout(this.autoHideTimeout);
          this.autoHideTimeout = null;
        }
        this.isLoading = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.bannerSub?.unsubscribe();
    if (this.autoHideTimeout != null) {
      clearTimeout(this.autoHideTimeout);
    }
  }

  get bannerMessage(): string {
    if (this.service.message) return this.service.message;
    return this.service.status === 406
      ? 'انتهت صلاحية الربط بمصلحة الضرائب، يجب تجديده'
      : 'المصلحة التجارية غير مرتبطة بمصلحة الضرائب';
  }

  connect($event?: Event) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    this.isLoading = true;
    if (this.autoHideTimeout != null) {
      clearTimeout(this.autoHideTimeout);
    }
    this.service.connectToTaxAuthority().subscribe({
      next: (res) => {
        this.service.hideBanner();
        window.location.href = res.url;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  close($event?: Event) {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    if (this.autoHideTimeout != null) {
      clearTimeout(this.autoHideTimeout);
    }
    this.service.hideBanner();
  }
}
